import { memo } from 'react';

import templates from '../templates';
import DefinitionPaneDefault from './DefinitionPaneDefault';

type TProps = {
  deck: TDeck;
  word: TWord;
  finished: boolean;
};

const DefinitionPane: React.FC<TProps> = ({ deck, word, finished }) => {
  if (deck.templateType !== TDeckTemplate.default) {
    const Pane = templates[deck.templateType].DefinitionPane;
    return <Pane word={word} finished={finished} />;
  }

  return <DefinitionPaneDefault word={word} finished={finished} />;
};

export default memo(DefinitionPane);
